import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import OrderSignResult from '../../components/order-sign-result/order-sign-result';
import { useSignResultHook } from '../../hooks/signResultHook';
import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';

const OrderSignResultPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { success, submitBtn, getDocsBtns, onClose } = useSignResultHook(
    'orderUcp',
    {
      submitPath: '/orders',
      closePath: '/orders',
      btnTitle: 'Перейти в реестр',
    }
  );

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/orders', title: 'Реестр' },
                {
                  link: `/orders/${id}`,
                  title: `Поставка ${id}`,
                },
              ]}
              iconType="order"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <OrderSignResult
              onClose={onClose}
              title={history.location.state.title}
              text={history.location.state.text}
              linkContent={getDocsBtns()}
              submitBtn={
                <a
                  href="https://dev.gp7.digital/documents/DecisionReleaseHybrid.pdf"
                  target="_blank"
                  download
                  rel="noreferrer"
                >
                  {submitBtn}
                </a>
              }
              success={success}
              loading={false}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default OrderSignResultPage;
